// Fetch list

export const FETCH = 'costTypes.FETCH'
export const FETCH_STARTED = 'costTypes.FETCH_STARTED'
export const FETCH_FULFILLED = 'costTypes.FETCH_FULFILLED'
export const FETCH_REJECTED = 'costTypes.FETCH_REJECTED'
export const FETCH_CANCELLED = 'costTypes.FETCH_CANCELLED'

export const SORTING_CHANGED = 'costTypes.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'costTypes.FETCH_ONE'
export const FETCH_ONE_STARTED = 'costTypes.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'costTypes.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'costTypes.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'costTypes.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'costTypes.SAVE'
export const SAVE_STARTED = 'costTypes.SAVE_STARTED'
export const SAVE_FULFILLED = 'costTypes.SAVE_FULFILLED'
export const SAVE_REJECTED = 'costTypes.SAVE_REJECTED'
export const SAVE_CANCELLED = 'costTypes.SAVE_CANCELLED'

// Delete

export const DELETE = 'costTypes.DELETE'
export const DELETE_STARTED = 'costTypes.DELETE_STARTED'
export const DELETE_FULFILLED = 'costTypes.DELETE_FULFILLED'
export const DELETE_REJECTED = 'costTypes.DELETE_REJECTED'
export const DELETE_CANCELLED = 'costTypes.DELETE_CANCELLED'
